import gql from 'graphql-tag';

export default gql(`
query getContractorCompanies($searchName: String, $company: String, $site: String){
  getContractorCompanies(searchName: $searchName, company: $company, site: $site) {
   status
   data
  }
}`);
